<template>
<div class="container-pano">
    <div class="loading-pano">
        <div id="title" class="loading-pano--text">33%</div>
    </div>
    <span class="icon-pano" v-on:click="DisplayRooms"></span>
<div class="room-appartement">
    <div class="room-appartement--title">Pièces</div>
    <div class="rooms-choice-appartement">

        <div style="display:flex; flex-direction:column; min-height:100vh " ref="rooms">
        </div>

    </div>
</div>
<div class="pano-appartement" ref="displayPano">
    <h3 class="title-appartement">Logis des Clos</h3>
    <Pano :source="urls[index]"  />
</div>
</div>
    
</template>


<script>
import {Pano} from 'vuejs-vr'
import CardPano from '../components/CardPano'
import Vue from 'vue'
export default {
    name : 'Appartement_1',
    components: {
        Pano
    },
    data () {
          return {
            urls: [require('../assets/imgs/jardin-test.png'),
            ],
            index: 0
          }
        },
    methods : {
        DisplayRooms : function(){
            window.scrollTo(0,0); 
            const title = document.getElementsByClassName('room-appartement--title')[0];
            const container = document.getElementsByClassName('room-appartement')[0];
            const icon = document.getElementsByClassName('icon-pano')[0];
            if(container.style.width) {
                
                container.style.width = ""
                title.style.fontSize = ""
                icon.style.backgroundImage = ""
            }
            else {
                
                container.style.width = '100vw'
               title.style.fontSize = '2.5rem'
               icon.style.backgroundImage = `url('${require('../assets/imgs/share.png')}')`
            }
            
        },
        CallbackCard : function(index) {
            console.log(index)
            console.log(this.urls)
            this.index = index;
            if (window.innerWidth < 1123)
            {
                this.DisplayRooms();
            }
        },
        LoadData : async function()
        {
            const title = document.getElementById('title');
            const loadingDOM = document.getElementsByClassName('loading-pano')[0];
            const firestore = this.$firestore;
            const storage = this.$storage;
            let loading = 0;
            const snapshot = await firestore.collection('appartements').get();
            let documentsLength = snapshot.docs.length;
            const a = 100/documentsLength
            let i = 0;
            snapshot.docs.forEach((doc) => {
                const img = new Image();
                
                img.onload = function()
                {
                    i+=1;

                    //creation de l'instance
                    const Card = Vue.extend(CardPano);
                    let  instance = new Card({
                        propsData : {
                            title : doc.data().title,
                            url : doc.data().url,
                            callback : this.CallbackCard,
                            index : i
                        }
                    })
                    instance.$mount();
                    this.$refs.rooms.appendChild(instance.$el)

                    //enregistrement de l'url de l'image pour le panorama
                    this.urls.push(doc.data().url)

                    //chargement 

                    loading += a;
                    title.innerText = parseInt(loading).toString() + '%'
                    console.log(parseInt(loading).toString() + '%')
                    if(loading >= 100)
                    {
                        setTimeout(() => {  loadingDOM.style.display = 'none' }, 1000);
                        
                    }

                }.bind(this)
                img.src = doc.data().url
                
            })

        }
    },


    mounted() {
       

      this.LoadData();

    }
    
}
</script>


<style scoped>


.loading-pano {
    position: absolute;
    width: 100vw;
    cursor: default;
    justify-content: center;
    align-items: center;
    display: flex;
    opacity: 0.6;
    z-index: 5;
    height: 100vh;
    background-color: black;
}

.loading-pano--text {
    
    color: aliceblue;
    font-size: 7rem;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: -0.4rem;
    font-weight: 600;
}

.container-pano {
    height:96vh;
    display: flex;
    overflow:hidden;
}

.icon-pano {
    background-image: url('../assets/imgs/list.png');
    position: absolute;
    left: 0;
    padding: 1.5rem 2rem;
    display: none;
    z-index: 3;
    margin: 0.25rem;
    border: 1px solid white;
    background-size: 83%;
    background-repeat: no-repeat;
    border-radius: 0.25rem;
    background-position: center;
    
}

.room-appartement--title {
    color: #343a40;
    font-size: 2rem;
    padding-bottom: 3rem;
    padding-top: 0.25rem;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: -0.08rem;
    box-shadow: 0px 10px 6px 0px rgba(0,0,0,0.27);

}

.rooms-choice-appartement {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    

}

.room-appartement {
    width: 30%;

    display: flex;
    flex-direction: column;
    background-color: white;
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
}

@media (max-width: 1123px) {
    .room-appartement {
        width: 0;
        position: absolute;
        left: 0;
        z-index: 2;
        transition: width 0.2s ease-in;
    }
    .pano-appartement {
        width: 100%!important;
    }
    .icon-pano {
        cursor: pointer;
        display: block;
        transition-duration: 0.2s;
    }

    .icon-pano--active {
        display: none!important;
    }

    .icon-pano:hover {
        border: 1px solid black;
    }

    .room-appartement--title {
        font-size: 0px;
    }
    
}

.pano-appartement {
    position: relative;
    cursor: pointer;
    width: 70%;
}

.title-appartement {
    position: absolute;
    transform: translate(-50%, 0);
    left: 50%;
    top: 0;
    padding: 0.25rem;
    color: white;
    font-size: 2.5rem;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: -0.08rem;
}

.container-pano a {
    color: black!important;
    font-family: Arial, Helvetica, sans-serif;
}

</style>